export default function Accordion() {
    return {
        MuiAccordion: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    boxShadow: 'none',
                    '&:first-of-type': {
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    '&.Mui-expanded': {
                        margin: 0
                    },
                    '&:before': {
                        display: 'none'
                    }
                }
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    margin: 0,
                    padding: '0 10px',
                    flexDirection: 'row-reverse',
                    '&.Mui-expanded': {
                        minHeight: '48px'
                    }
                },
                content: {
                    '&.Mui-expanded': {
                        margin: '0'
                    },
                    padding: '0 0 0 10px'
                }
            }
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    padding: 0,
                    borderTop: '1px solid #e3e3e3'
                }
            }
        }
    };
}
